<div class="client-select-wrapper">
  <div class="client-select-container">
    <div class="modal-header">
      <div class="header-left">
        <i class="fa fa-users header-icon"></i>
        <div class="header-text">
          <h4>Sélection du client</h4>
          <p>Choisissez un client pour continuer</p>
        </div>
      </div>
      <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
    </div>

    <div class="modal-body">
      <!-- Search Bar -->
      <div class="search-container">
        <div class="search-input-wrapper">
          <i class="fa fa-search search-icon"></i>
          <input 
            type="text" 
            class="form-control search-input" 
            placeholder="Rechercher par nom, prénom ou téléphone..." 
            (input)="onInputChange($event)"
          >
        </div>
        <button class="btn btn-primary add-client-btn" (click)="goToAddClientForm()">
          <i class="fa fa-plus"></i>
          <span>Nouveau</span>
        </button>
      </div>

      <!-- Client List Section -->
      <div class="client-list-wrapper">
        <!-- Loader -->
        <div *ngIf="isLoading" class="list-loader-container">
          <div class="pulse-loader"></div>
          <p>{{ searchQuery ? 'Recherche en cours...' : 'Chargement des clients...' }}</p>
        </div>

        <!-- Client List -->
        <ng-container *ngIf="!isLoading">
          <div *ngIf="clientsToDisplay && clientsToDisplay.length > 0" class="client-cards">
            <div *ngFor="let client of clientsToDisplay" 
                class="client-card" 
                (click)="closeDialogAndGoToOrderPage(client)">
              <div class="client-card-content">
                <div class="client-avatar">
                  {{ client.firstName?.charAt(0) }}{{ client.lastName?.charAt(0) }}
                </div>
                <div class="client-details">
                  <h5>{{ client.lastName }} {{ client.firstName }}</h5>
                  <div class="client-contact">
                    <span *ngIf="client.phoneNumber" class="client-phone">
                      <i class="fa fa-phone"></i> {{ client.phoneNumber }}
                    </span>
                    <span *ngIf="client.email" class="client-email">
                      <i class="fa fa-envelope"></i> {{ client.email }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="select-btn">
                <i class="fa fa-check-circle"></i>
              </div>
            </div>
          </div>
          
          <!-- No Results -->
          <div *ngIf="!clientsToDisplay || clientsToDisplay.length === 0" class="no-results">
            <div class="no-results-icon">
              <i class="fa fa-user-slash"></i>
            </div>
            <h5>Aucun client trouvé</h5>
            <p>Essayez avec un autre terme ou ajoutez un nouveau client</p>
            <button class="btn btn-outline-primary mt-3" (click)="goToAddClientForm()">
              <i class="fa fa-user-plus me-2"></i>Ajouter un client
            </button>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="closeDialog()">
        Annuler
      </button>
    </div>
  </div>
</div>
